import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Clock, ArrowLeft } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

interface ComingSoonPageProps {
  featureName?: string;
}

export function ComingSoonPage({ featureName }: ComingSoonPageProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <div 
      className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4"
      style={{ color: colors.text }}
    >
      <div 
        className="w-20 h-20 rounded-full flex items-center justify-center mb-6"
        style={{ backgroundColor: colors.surfaceHover }}
      >
        <Clock className="w-10 h-10" style={{ color: colors.primary }} />
      </div>
      
      <h1 
        className="text-2xl font-bold mb-3"
        style={{ fontFamily: 'Sora, sans-serif' }}
      >
        {t('common.comingSoon')}
      </h1>
      
      {featureName && (
        <p 
          className="text-lg mb-2"
          style={{ color: colors.textSecondary }}
        >
          {featureName}
        </p>
      )}
      
      <p 
        className="max-w-md mb-8"
        style={{ color: colors.textSecondary, fontFamily: 'Inter, sans-serif' }}
      >
        {t('comingSoon.description', 'We\'re working hard to bring you this feature. Stay tuned for updates!')}
      </p>
      
      <button
        onClick={() => navigate({ to: '/dashboard' })}
        className="flex items-center gap-2 px-6 py-3 rounded-lg transition-all hover:opacity-90"
        style={{ 
          background: 'linear-gradient(135deg, #594BFF 0%, #8B7FFF 100%)',
          color: '#FFFFFF',
          fontFamily: 'Sora, sans-serif',
          fontWeight: 600,
        }}
      >
        <ArrowLeft className="w-4 h-4" />
        {t('common.backToDashboard', 'Back to Dashboard')}
      </button>
    </div>
  );
}
